import * as _ from 'lodash'

export default function currentLocationGroup(state = null, action = {}) {
  if (action.type === 'CURRENT_LOCATION_GROUP') {
    return _.get(action, 'currentLocationGroup', null)
  }
  return state
}
